import React, { useEffect, useState, Component } from 'react';
import { Box, Alert, AlertTitle, IconButton, Snackbar, Slide, SlideProps } from '@mui/material';
import { Icon } from '@iconify/react';
export type ToastType = 'success' | 'error' | 'warning' | 'info';
export interface ToastProps {
  open: boolean;
  message: string;
  title?: string;
  type?: ToastType;
  duration?: number;
  onClose: () => void;
}
function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="left" data-id="element-1297" />;
}
export const Toast: React.FC<ToastProps> = ({
  open,
  message,
  title,
  type = 'success',
  duration = 4000,
  onClose
}) => {
  const [isOpen, setIsOpen] = useState(open);
  useEffect(() => {
    setIsOpen(open);
  }, [open]);
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsOpen(false);
    onClose();
  };
  const iconMap = {
    success: 'lucide:check-circle',
    error: 'lucide:x-circle',
    warning: 'lucide:alert-triangle',
    info: 'lucide:info'
  };
  return <Snackbar open={isOpen} autoHideDuration={duration} onClose={handleClose} anchorOrigin={{
    vertical: 'top',
    horizontal: 'right'
  }} TransitionComponent={SlideTransition} sx={{
    maxWidth: '400px',
    '& .MuiPaper-root': {
      width: '100%'
    }
  }} data-id="element-1298">
      <Alert severity={type} variant="filled" sx={{
      width: '100%',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      borderRadius: '6px',
      alignItems: 'center',
      '&.MuiAlert-filledSuccess': {
        backgroundColor: '#0B7923'
      },
      '&.MuiAlert-filledError': {
        backgroundColor: '#AE2A19'
      },
      '&.MuiAlert-filledWarning': {
        backgroundColor: '#B38600'
      },
      '&.MuiAlert-filledInfo': {
        backgroundColor: '#0052CC'
      }
    }} icon={<Icon icon={iconMap[type]} width={24} height={24} style={{
      color: 'white'
    }} data-id="element-1300" />} action={<IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} data-id="element-1301">
            <Icon icon="lucide:x" width={16} height={16} data-id="element-1302" />
          </IconButton>} data-id="element-1299">
        {title && <AlertTitle sx={{
        fontWeight: 600
      }} data-id="element-1303">
            {title}
          </AlertTitle>}
        {message}
      </Alert>
    </Snackbar>;
};
export default Toast;